import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStoreService } from './auth-store.service';

function redirectToLogin(authStore: AuthStoreService, router: Router) {
  if (authStore.isAuthenticated() && !authStore.canAccessOrganizationApp()) {
    authStore.clearSession();
  }

  return router.createUrlTree(['/login']);
}

export const organizationAppGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (!authStore.isAuthenticated() || !authStore.canAccessOrganizationApp()) {
    return redirectToLogin(authStore, router);
  }

  return true;
};

export const questionnaireAdminGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (!authStore.isAuthenticated() || !authStore.canAccessOrganizationApp()) {
    return redirectToLogin(authStore, router);
  }

  if (authStore.canManageQuestionnaires()) {
    return true;
  }

  return router.createUrlTree(['/dashboard/kyc']);
};

export const userManagementGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (!authStore.isAuthenticated() || !authStore.canAccessOrganizationApp()) {
    return redirectToLogin(authStore, router);
  }

  if (authStore.canManageUsers()) {
    return true;
  }

  return router.createUrlTree(['/dashboard/kyc']);
};

export const matrixAdminGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (!authStore.isAuthenticated() || !authStore.canAccessOrganizationApp()) {
    return redirectToLogin(authStore, router);
  }

  if (authStore.canManageMatrices()) {
    return true;
  }

  return router.createUrlTree(['/dashboard/kyc']);
};

export const businessManagementGuard: CanActivateFn = () => {
  const authStore = inject(AuthStoreService);
  const router = inject(Router);

  if (!authStore.isAuthenticated() || !authStore.canAccessOrganizationApp()) {
    return redirectToLogin(authStore, router);
  }

  if (authStore.canManageBusinesses()) {
    return true;
  }

  return router.createUrlTree(['/dashboard/kyc']);
};
